import script from "./WelcomeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSection.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeSection.vue?vue&type=style&index=0&id=7469bb57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7469bb57"]])

export default __exports__